var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"privacy"}},[_c('Menu'),_c('b-container',{attrs:{"id":"privacy-wrapper"}},[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.$t('contact.privacy')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('privacy.text'))}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }